import { render, staticRenderFns } from "./DischargeSummary.vue?vue&type=template&id=8e4027e0&"
import script from "./DischargeSummary.vue?vue&type=script&lang=js&"
export * from "./DischargeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports